<template>
  <q-dialog v-model="confirm" persistent>
    <q-card>
      <q-card-section class="row items-center">
        <q-avatar icon="delete" color="negative" text-color="white" />
        <span class="q-ml-sm">Do you want to delete this question?.</span>
      </q-card-section>
      <q-card-actions align="right">
        <q-btn flat label="Cancel" color="warning" v-close-popup />
        <q-btn flat :loading="isSubmitted" label="Confirm" color="positive" @click="confirmDeleteQuestion" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { useQuasar } from 'quasar' 
import { ref } from 'vue'
import axios from 'axios'
import EventBus from "@/EventBus"
export default {
  setup () {
    const token = ref(window.$cookies.get(process.env.VUE_APP_API_KEY).token)
    const $q = useQuasar()
    const confirm = ref(false)
    const id = ref(null)
    const isSubmitted = ref(false)

    EventBus.on("deleteQuestionBankModal",(val) => {
        id.value = val.id
        confirm.value = val.status
    })

    const confirmDeleteQuestion = () => {
      isSubmitted.value = true; 
      axios.delete(process.env.VUE_APP_API_URL + '/question/bank/'+ id.value,{
        headers: { 'Authorization': `Bearer ${token.value}`},
      }).then(() => {
          isSubmitted.value = false
          confirm.value = false
          $q.notify({
            color: 'positive',
            textColor: 'white',
            icon: 'check_circle',
            message: 'Record Deleted'
          })
         EventBus.emit("refreshModuleBankQuestion")
        }).catch((e) => {
         isSubmitted.value = false
         confirm.value = false
         $q.notify({
            color: 'negative',
            textColor: 'white',
            icon: 'warning',
            message: e.response.data.message
          })
      })
    }

    return {
      token,
      confirm,
      id,
      isSubmitted,
      confirmDeleteQuestion
    }
  }
}
</script>